import { useEffect, useState } from "react";
import { listChildren, saveChild, type ChildInput } from "../lib/firestore";
import type { Child } from "../types";
import { ChildForm } from "./ChildForm";
import { ageDisplay } from "../types";

type Props = { uid: string };

export function RosterPage({ uid }: Props) {
  const [children, setChildren] = useState<Child[] | null>(null);
  const [editing, setEditing] = useState<Child | null | "new">(null);

  const refresh = async () => {
    setChildren(await listChildren(uid));
  };

  useEffect(() => {
    refresh();
  }, [uid]);

  const handleSubmit = async (input: ChildInput) => {
    const id = editing && editing !== "new" ? editing.id : null;
    await saveChild(uid, id, input);
    setEditing(null);
    await refresh();
  };

  if (children === null) return <p className="p-4 text-gray-500">Loading roster…</p>;

  return (
    <div className="p-4 max-w-2xl">
      <h2 className="text-xl font-semibold mb-4">Roster</h2>
      {editing !== null ? (
        <ChildForm
          child={editing === "new" ? null : editing}
          onSubmit={handleSubmit}
          onCancel={() => setEditing(null)}
        />
      ) : (
        <>
          <button
            onClick={() => setEditing("new")}
            className="mb-3 text-[#ff6b35] font-medium"
          >
            + Add child
          </button>
          <ul className="divide-y border rounded">
            {children.length === 0 && (
              <li className="p-3 text-gray-500">No children yet — add your first.</li>
            )}
            {children.map((c) => (
              <li
                key={c.id}
                className="p-3 flex justify-between items-center cursor-pointer hover:bg-gray-50"
                onClick={() => setEditing(c)}
              >
                <span>
                  <span className="font-medium">{c.name_en}</span>
                  <span className="text-gray-500 ml-2">{c.name_zh}</span>
                </span>
                <span className="text-sm text-gray-400">{ageDisplay(c.date_of_birth)}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
